import React, { createContext, useContext } from 'react';

/**
 * Default S3 folder for media uploaded within a given admin area, so assets are
 * organised by source (custom-pages/, itineraries/, config/) instead of one
 * flat dump. A `MediaDropField` uses its explicit `folder` prop if given, else
 * the nearest provider's value, else the API default ("website").
 *
 * Conventions (keep these stable - they become S3 key prefixes / CDN paths):
 */
export const MEDIA_FOLDER = {
  customPages: 'custom-pages',
  itineraries: 'itineraries',
  config: 'config',
} as const;

const MediaFolderContext = createContext<string | undefined>(undefined);

export const MediaFolderProvider = ({
  folder,
  children,
}: {
  folder: string;
  children: React.ReactNode;
}): React.JSX.Element => (
  <MediaFolderContext.Provider value={folder}>{children}</MediaFolderContext.Provider>
);

export const useMediaFolder = (): string | undefined => useContext(MediaFolderContext);
